/**
 * subject-context-search-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

import { TypedData, TypedDataHolder } from "../../../common/data/typed-data";
import { SearchTerm } from "../../../search/search-node";
import { SubjectContextType } from "../../../subjects/subject-context-type";

/**
 * A client transmits a {@link SubjectContextSearchRequest} to search for a
 * context with a given set of search and filter keys.
 */
export class SubjectContextSearchRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_SUBJECT_CONTEXT_SEARCH;
	public static tag : MessageTag = MessageTag.REQ_SUBJECT_CONTEXT_SEARCH;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SUBJECT_CONTEXT_SEARCH);
  }

  /**
   * Construct a new {@link SubjectContextSearchRequest}.
   */
  constructor (
    public contextType : SubjectContextType,
    public searchPath : SearchTerm[],
    public filterPath : SearchTerm[]
  )
  {
    super();
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/search/subject-context-search-request.ts